import React from "react";
import { useForm, useFormState } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import { yup } from "utils";

import { useAddGatedCustomersAction } from "./useAddGatedCustomersAction";

const validationSchema = () => {
  const emailSchema = yup.string().email();

  return {
    emails: yup
      .array()
      .min(1, "Please enter at least one email address")
      .test("is-valid-email", (value, ctx) => {
        const invalidEmails = value?.filter((v) => {
          return !emailSchema.isValidSync(v);
        });

        return invalidEmails.length > 0
          ? ctx.createError({
              message: (
                <span>
                  <b>{invalidEmails.join(", ")}</b>{" "}
                  {invalidEmails.length > 1
                    ? "are not valid email addresses"
                    : "is not a valid email address"}
                </span>
              ),
            })
          : true;
      }),
  };
};

export function useGatedCustomersForm(onDone) {
  const formProps = useForm({
    mode: "onChange",
    resolver: yupResolver(yup.object(validationSchema())),
  });
  const { addGatedCustomers, loading } = useAddGatedCustomersAction(onDone);

  const { isValid, isDirty } = useFormState({ control: formProps.control });

  return {
    formProps: formProps,
    isReady: isValid && isDirty,
    submit: addGatedCustomers,
    isSubmitting: loading,
  };
}

export default useGatedCustomersForm;
